import React from 'react';
import { Vegan, SaladIcon, ThermometerSun  } from 'lucide-react';
import { menu, todaysVenues } from '../mySettings';

const doVegetarian = (isVeggie) => {
  if (!isVeggie) return false;
  
  return (
    <SaladIcon 
      size={20} 
      color={'green'} 
      className='menuDietaryIcon ml-2'
    /> 
  );
}
const doVegan = (isVegan) => {
  if (!isVegan) return false;
  
  return (
    <Vegan 
      size={18} 
      color={'green'} 
      className='menuDietaryIcon ml-2'
    /> 
  );
}
const doSpicy = (isSpicy) => {
  if (!isSpicy) return false;
  
  return (
    <ThermometerSun 
      size={18} 
      color={'red'} 
      className='menuDietaryIcon ml-2'
    /> 
    
  );
}
const MenuItem = (pizza) => {
  if (!pizza.active) { return false }
  return (
    <div key={pizza.id} className="border rounded-lg p-4 text-center">
      <img 
        src={pizza.image} 
        alt={pizza.name} 
        className="w-full h-70 object-cover rounded-lg mb-4"
      />
      <h3 className="font-bold text-xl">
        {pizza.name}
        {
          doVegetarian(pizza.vegetarian)
        }
        {
          doVegan(pizza.veganOption)
        }
        {
          doSpicy(pizza.spicy)
        }
      </h3>
      <p className="text-gray-600 mb-2">{pizza.description}</p>
      <div className="flex justify-between items-center">
        {/* <span className="text-lg font-semibold">£{pizza.price.toFixed(2)}</span> */}
        {/* <button 
          onClick={() => addToCart(pizza)}
          className="bg-amber-500 text-white px-3 py-1 rounded hover:bg-amber-600"
        >
          Add to Cart
        </button> */}
      </div>
      <div className="mt-4">
        <h4>Allergen Information:</h4>
        <p>{pizza.allergens}</p>
      </div>
    </div>
  );
}

function MenuPage({ addToCart }) {
  const pizzaMenu = [
    ...menu
  ];

  return (
    <div className="p-4">
      <h2 className="text-3xl font-bold mb-4">Order Here</h2>
      <a href="https://deliveroo.co.uk/menu/london/south-woodford/djenerate-ltd-108-cadogan-gardens/?utm_campaign=organic&utm_medium=referrer&utm_source=menu_share">
        <img src="/img/deliveroo.svg" alt="Deliveroo" className="h-10" />
      </a>
      {/* <h3 className="text-2xl mb-4">Pick up from:</h3> 
      <div  className="text-2xl mb-4">
        <span className="font-bold">{todaysVenues[0].venue.label}</span> on <span className="font-bold">{todaysVenues[0].day} {todaysVenues[0].date}</span> from <span className="font-bold">{todaysVenues[0].start}</span> to <span className="font-bold">{todaysVenues[0].end}</span>
      </div>
      <p  className="mb-6">(Delivery is not available)</p> */}
      <br/><br/>
      <h2 className="text-3xl font-bold mb-4">Our Pizzas</h2>
      <div className="grid md:grid-cols-3 gap-4 mb-16">
        {pizzaMenu.map(pizza => (
          MenuItem(pizza)
        ))}
      </div>
      <div  className="text-1xl grid grid-cols-8 gap-1 mb-12">
         <div className="mb-4">
          <SaladIcon 
            size={50} 
            color={'green'}
            hover='Vegetarian'
            
          />
          <p>Vegetarian option available</p>
        </div>
        <div className="ml-2">
          <Vegan 
            size={40} 
            color={'green'}
          />
          <p>Plant based option available</p>
        </div>
        <div className="ml-2">
          <ThermometerSun 
            size={40} 
            color={'red'}
          />
          <p>Spicy</p>
        </div>
      </div>
      <div className="text-center p-12 hocMid">
        <ul className="text-3xl gap-2 mb-16 items-center">
          <li className="mb-3">We use vegetarian cheese</li>
          <li className="mb-3">Our tomato sauce uses imported Italian San Marzano tomatoes</li>
          <li className="mb-3">Every dough ball is hand-stretched</li>
          <li className="mb-3">Every pizza is hand made with passion</li>
        </ul>
      </div>
      <div>
        <h4>Allergen Information:</h4>
        <p>All pizzas contain wheat in the base, If you have allergies or food intolerances please let us know when ordering so we can prepare and package your order appropriately, Our kitchen stores and uses nuts in some dishes</p>
      </div>
    </div>
  );
}

export default MenuPage;
